/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Submit from 'bundles/authentication/components/Submit';
import { EMAIL_CONSTRAINT } from 'bundles/authentication/constants';
import EmailInput from 'bundles/authentication/shared/EmailInput';
import Form from 'bundles/authentication/shared/Form';
import Separator from 'bundles/authentication/shared/Separator';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/authentication';

type Props = {
  onSubmit: (values: { email: string }) => void;
  onRequestMagicLink: () => void;
  submitCTALabel?: string;
  submitCTATrackingName?: string;
};

const TrackedSubmit = withSingleTracked({ type: 'BUTTON' })(Submit);

const styles = {
  form: css`
    display: grid;
    grid-gap: 12px;
    grid-template-columns: 1fr;
  `,
  submit: css`
    margin-top: 12px;
  `,
  separator: css`
    margin: 4px 0;
  `,
};

const ForgotPasswordForm = ({
  onSubmit,
  onRequestMagicLink,
  submitCTALabel = _t('Reset Password'),
  submitCTATrackingName = 'reset_page_button',
}: Props) => {
  return (
    <Form
      css={styles.form}
      constraints={{ email: EMAIL_CONSTRAINT }}
      // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      onSubmit={(values) => onSubmit({ email: values?.email })}
    >
      <EmailInput />
      <TrackedSubmit css={styles.submit} trackingName={submitCTATrackingName}>
        {submitCTALabel}
      </TrackedSubmit>
      <>
        <Separator css={styles.separator} text={_t('or')} />
        <TrackedSubmit
          css={styles.submit}
          trackingName="send_login_link_button"
          onClick={onRequestMagicLink}
          secondary={true}
        >
          {_t('Email me a login link')}
        </TrackedSubmit>
      </>
    </Form>
  );
};

export default ForgotPasswordForm;
